export default __webpack_public_path__ + "static/media/play-circle-gestalt.464d5ffb.svg";